module.exports = __webpack_public_path__ + "static/media/landing-mapp-logo.2db25e41.svg";